var path = 'src/app/patients/genetics/genetics.html';
var html = "<h1 class=page-header>Genetics <small>{{cohort.name}}</small></h1> <div genetics-component patient=patient cohort=cohort></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/genetics/genetics.html
 ** module id = 477
 ** module chunks = 0
 **/